// extracted by mini-css-extract-plugin
export default {"center":"ChangePassword_center__OvpkH","header":"ChangePassword_header__DyK0Y"};